"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixBoxedInText = fixBoxedInText;
function fixBoxedInText(tex) {
    return tex.replace(new RegExp(`\\\\text\\s*{\\s*([^}]*)}`, "g"), (token) => {
        return token.replace(new RegExp(`[$]?(\\\\boxed{[^}]*})`, "g"), (token) => {
            if (token.startsWith("$")) {
                return token;
            }
            return `$${token}$`;
        });
    });
}
